import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accessKeys: { initialLoad: true },
  disabledKeys: {},
  onboardingStatus: {},
};

const userAccess = createSlice({
  name: "userAccess",
  initialState,
  reducers: {
    setAccessKeys: (state, action) => {
      state.accessKeys = action.payload;
    },
    setDisabledKeys: (state, action) => {
      state.disabledKeys = action.payload;
    },
    setOnboardingStatus: (state, action) => {
      state.onboardingStatus = action.payload;
    },
  },
});

export const { setAccessKeys, setDisabledKeys, setOnboardingStatus } = userAccess.actions;

export default userAccess.reducer;
